import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';
import { CheckIcon, MinusIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'tw:group/checkbox tw:peer tw:relative tw:flex tw:size-4 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-[4px] tw:border tw:border-border tw:bg-background tw:shadow-xs tw:transition-shadow tw:outline-none tw:group-has-disabled/field:opacity-50 tw:after:absolute tw:after:-inset-x-3 tw:after:-inset-y-2 tw:not-data-disabled:hover:bg-primary tw:data-indeterminate:not-data-disabled:hover:bg-background tw:data-indeterminate:not-data-disabled:hover:border-primary tw:data-checked:not-data-disabled:hover:opacity-80 tw:focus-visible:border-transparent tw:focus-visible:ring-3 tw:focus-visible:ring-ring/50 tw:data-checked:focus-visible:border-ring tw:data-disabled:cursor-not-allowed tw:data-disabled:bg-muted tw:data-disabled:shadow-none tw:data-disabled:text-muted-foreground tw:data-checked:data-disabled:bg-muted tw:data-checked:data-disabled:border-border tw:data-checked:data-disabled:shadow-xs tw:data-indeterminate:data-disabled:shadow-xs tw:aria-invalid:border-destructive tw:aria-invalid:ring-3 tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:border-destructive/50 tw:dark:aria-invalid:ring-destructive/40 tw:data-checked:border-primary tw:data-checked:bg-primary tw:data-checked:text-primary-foreground tw:data-indeterminate:text-foreground tw:data-checked:data-disabled:text-muted-foreground tw:data-indeterminate:data-disabled:text-muted-foreground',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="tw:grid tw:place-content-center tw:text-current tw:transition-none tw:[&>svg]:size-3.5 tw:group-data-indeterminate/checkbox:hidden"
      >
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="tw:hidden tw:place-content-center tw:text-current tw:transition-none tw:[&>svg]:size-3.5 tw:group-data-indeterminate/checkbox:grid"
      >
        <MinusIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
